import { ORDER_STATUS } from '../component/page/company/order/const/order-status';
import { Company } from '../interface/company';
import { MkgUser } from '../interface/user';
import { API_ERRORS } from '../shared/lists/errors';
import { roles } from '../shared/lists/roles';

export class CreditReleaseUtilities {

  /**
   * Quem vê e decide as liberações por títulos vencidos (D16): administrador da empresa (dono ou
   * papel admin), com a flag `blockOverdueClients` ligada. Não passa pelo perfil de acesso.
   * O menu, a guarda de rota e a tela usam esta mesma regra; a API barra de qualquer jeito.
   */
  static canManage(company: Company, user: MkgUser): boolean {
    return Boolean(company?.blockOverdueClients) && Boolean(user) && user.getRoleIn(company) === roles.admin.id;
  }

  /** Código de OS ou orçamento exibido na lista de liberações */
  static osDocumentCode(os: { isBudgetOrRejected: boolean; budgetCode?: number; codeSystem?: number }): string {
    return os.isBudgetOrRejected ? `Orçamento ${os.budgetCode}` : `OS ${os.codeSystem}`;
  }

  /** Código de pedido ou PDV exibido na lista de liberações, pelo status em que o documento é gravado */
  static orderDocumentCode(status: ORDER_STATUS, code: number): string {
    switch (status) {
      case ORDER_STATUS.BUDGET:
        return `Orçamento ${code}`;
      case ORDER_STATUS.PDV_BUDGET:
      case ORDER_STATUS.PDV_WITHOUT_ISSUED_INVOICE:
        return `PDV ${code}`;
      default:
        return `Pedido ${code}`;
    }
  }

  /** O erro 582 da barreira da API: o cliente tem título vencido e o salvamento foi recusado */
  static isClientHasOverdueTitlesError(error: unknown): boolean {
    return (error as { error?: { error?: number } })?.error?.error === API_ERRORS.clientHasOverdueTitles;
  }
}
